import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { FaShippingFast } from 'react-icons/fa';
export var ShippingSelect = function ShippingSelect(props) {
  // console.log('SHIPPING SELECT',props)
  var _props$deliveryOption = props.deliveryOptions,
      deliveryOptions = _props$deliveryOption === void 0 ? [] : _props$deliveryOption,
      _props$deliveryCosts = props.deliveryCosts,
      deliveryCosts = _props$deliveryCosts === void 0 ? [] : _props$deliveryCosts,
      title = props.title,
      _props$setFieldValue = props.setFieldValue,
      setFieldValue = _props$setFieldValue === void 0 ? function () {
    return "";
  } : _props$setFieldValue,
      _props$setShippingMod = props.setShippingMode,
      setShippingMode = _props$setShippingMod === void 0 ? function () {
    return "";
  } : _props$setShippingMod;
  var name = 'retailDelivery';

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      travel = _useState2[0],
      setTravel = _useState2[1];

  var handleOptionChange = function handleOptionChange(changeEvent) {
    if (changeEvent.target.value) {
      var value = changeEvent.target.value.toLowerCase();
      setFieldValue(name, value);
      setShippingMode(value);
      return setTravel(value);
    } else {
      console.log('SOMETHING WENT WRONG', changeEvent === null || changeEvent === void 0 ? void 0 : changeEvent.target);
    }
  };

  useEffect(function () {
    if (Array.isArray(deliveryOptions) && deliveryOptions.length && !travel) {
      handleOptionChange({
        target: {
          value: deliveryOptions[0]
        }
      });
    }
  }, [deliveryOptions]);

  function jsUcfirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("select", {
    name: "retailDelivery",
    className: "form-control select-center ",
    style: {
      textTransform: 'uppercase'
    },
    value: travel || '',
    onChange: function onChange(e) {
      return handleOptionChange(e);
    }
  }, deliveryOptions.length >= 1 ? "" : /*#__PURE__*/React.createElement("option", null, "No online ordering setup for this location"), deliveryOptions.map(function (option, index) {
    var childtitle = option;

    if (option === "dispatch") {
      childtitle = "delivery";
    }

    var cost = ' ' + deliveryCosts[index] + ' ';
    return /*#__PURE__*/React.createElement("option", {
      title: jsUcfirst(childtitle),
      id: title + option,
      name: name,
      key: 'option' + index //isPickup={option === "pickup"}
      ,
      value: option.toLowerCase(),
      selected: travel,
      deliverytime: cost || ""
    }, cost + option.toLowerCase());
  })));
};